import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'truncated-text',
  templateUrl: './truncated-text.component.html',
  styleUrls: ['./truncated-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TruncatedTextComponent implements OnChanges, AfterViewInit {

  @Input() content: string;
  @Input() small = false;

  @ViewChild('containerRef') containerRef: ElementRef;
  @ViewChild('contentRef') contentRef: ElementRef;

  truncated$ = new BehaviorSubject(true);
  showToggle$ = new BehaviorSubject(true);

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => this.updateToggle(), 0);
  }

  ngAfterViewInit() {
    setTimeout(() => this.updateToggle(), 0);
  }

  updateToggle() {
    const containerHeight = this.containerRef.nativeElement.offsetHeight;
    const contentHeight = this.contentRef.nativeElement.scrollHeight;

    this.showToggle$.next(contentHeight > containerHeight);
  }

  toggle() {
    this.truncated$.next(!this.truncated$.getValue());
  }

}

